import React from 'react';
import { Button, CircularProgress } from '@mui/material';
import { FileDownload as ExportIcon } from '@mui/icons-material';

interface DialogActionButtonsProps {
  canExport: boolean;
  isLoading: boolean;
  isExporting: boolean;
  onCancel: () => void;
  onExport: () => void;
}

export const DialogActionButtons: React.FC<DialogActionButtonsProps> = ({
  canExport,
  isLoading,
  isExporting,
  onCancel,
  onExport,
}) => (
  <>
    <Button onClick={onCancel} disabled={isLoading || isExporting}>
      Cancel
    </Button>
    <Button
      onClick={onExport}
      variant="contained"
      disabled={!canExport || isLoading || isExporting}
      startIcon={isLoading || isExporting ? <CircularProgress size={20} /> : <ExportIcon />}
    >
      {isLoading || isExporting ? 'Exporting...' : 'Export to PDF'}
    </Button>
  </>
);
